import { createContext } from 'react'

import { AddEditAdUnitContextType } from './types'

export const AddEditAdUnitContext = createContext<AddEditAdUnitContextType>(
  {} as AddEditAdUnitContextType,
)
